import { c as _c } from "react/compiler-runtime";
interface SplitTestOriginalImageProps {
  className?: string;
}
export function SplitTestOriginalImage(t0) {
  const $ = _c(11);
  const {
    className
  } = t0;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <g filter="url(#split-test-original-shadow)"><rect x="20" y="20" width="98" height="98" rx="16" fill="var(--color-system-primary-200, #b9e6fd)" /></g>;
    t2 = <circle cx="35.8457" cy="30.8457" r="3" fill="white" fillOpacity="0.5" />;
    t3 = <circle cx="45.8457" cy="30.8457" r="3" fill="white" fillOpacity="0.5" />;
    t4 = <circle cx="55.8457" cy="30.8457" r="3" fill="white" fillOpacity="0.5" />;
    t5 = <rect x="72.6562" y="42.6582" width="37" height="5" rx="2.5" fill="white" fillOpacity="0.5" />;
    t6 = <rect x="72.6562" y="51.6582" width="37" height="5" rx="2.5" fill="white" fillOpacity="0.5" />;
    t7 = <rect x="72.6562" y="60.6582" width="20" height="5" rx="2.5" fill="white" fillOpacity="0.5" />;
    t8 = <rect x="31.6562" y="42.6582" width="34" height="62" rx="8" fill="white" fillOpacity="0.5" />;
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
    $[4] = t5;
    $[5] = t6;
    $[6] = t7;
    $[7] = t8;
  } else {
    t1 = $[0];
    t2 = $[1];
    t3 = $[2];
    t4 = $[3];
    t5 = $[4];
    t6 = $[5];
    t7 = $[6];
    t8 = $[7];
  }
  let t9;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <defs><filter id="split-test-original-shadow" x="-10.8" y="-6.8" width="159.6" height="159.6" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB"><feFlood floodOpacity="0" result="BackgroundImageFix" /><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" /><feOffset dy="4" /><feGaussianBlur stdDeviation="15.4" /><feComposite in2="hardAlpha" operator="out" /><feColorMatrix type="matrix" values="0 0 0 0 0.360947 0 0 0 0 0.509097 0 0 0 0 0.586538 0 0 0 0.1 0" /><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_original" /><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_original" result="shape" /></filter></defs>;
    $[8] = t9;
  } else {
    t9 = $[8];
  }
  let t10;
  if ($[9] !== className) {
    t10 = <svg width="149" height="138" viewBox="0 0 149 138" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" className={className}>{t1}{t2}{t3}{t4}{t5}{t6}{t7}{t8}{t9}</svg>;
    $[9] = className;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  return t10;
}